import { Text } from "../../../components/text/text";
import { useEffect, useState } from "react"
import { Header } from "../../../components/header/header"
import { ProgressBar } from "../../../components/progressBar/progressBar"
import { useSelector } from "react-redux"
import KpiAPI from "../../../api/KpiAPI"

import styles from "./tasksPage.module.css"

export const TasksPage = () => {
    const curDate = new Date()

    const [tasks, setTasks] = useState([]);
    const cafeId = useSelector(state => state.user.userData?.cafeId);

    useEffect(() => {
        if (!cafeId) return;
        KpiAPI
            .fetchKpiScheme(cafeId)
            .then(res => setTasks(res))
            .catch(() => setTasks([]));
    }, [cafeId]);

    return (
        <>
            <Header title="Продажи" />

            <div className={styles.page_subtitle_container}>
                <Text as="div" variant="h3" className={styles.page_subtitle} >Продажи по категориям</Text>
                <Text as="div" variant="body" className={styles.page_date} >{String(curDate.getDate()).padStart(2, "0")}.{String(curDate.getMonth() + 1).padStart(2, "0")}</Text>
            </div>

            <div className={styles.tasks_container}>
                {
                    tasks.map(data =>
                        <ProgressBar key={data.id} date={data.kpiDate} title={data.categoryName} sold={data.completedRevenue} target={data.goalRevenue} />
                    )
                }
            </div>
        </>
    )
}